// Copyright (c) 2023 Proto Labs, Inc. All Rights Reserved.

import i18n from '@/i18n';
import { mutationTypes as infoMutations } from '@/store/info';

const newToast = (
    store: any,
    color: string,
    text: string,
    icon: string,
    links?: Array<any>,
    timer?: number
) =>
    store.commit(infoMutations.ADD_TOAST, {
        show: true,
        color: color,
        icon: icon,
        text: i18n.global.t(text),
        links: links,
        timer: timer || 6000,
    });

const newBanner = (
    vue: any,
    id: string,
    color: string,
    icon: string,
    text: string,
    links = []
) =>
    vue.$store.commit(infoMutations.ADD_BANNER, {
        id: id,
        color: color,
        icon: icon,
        text: text,
        links: links,
    });

export const errorToast = (store: any, text: string, links?: Array<any>) =>
    newToast(store, 'red', text, 'warning_small', links);

export const successToast = (store: any, text: string, links?: Array<any>) =>
    newToast(store, 'green', text, 'check_circle_small', links);

export const infoToast = (
    vue: any,
    text: string,
    icon: string,
    links?: Array<any>
) => newToast(vue, 'blue', text, icon, links);

export const errorBanner = (vue: any, id = '', text = '', links = []) =>
    newBanner(vue, id, 'red', 'warning_small', text, links);

export const successBanner = (vue: any, id = '', text = '', links = []) =>
    newBanner(vue, id, 'green', 'warning_small', text, links);

export const infoBanner = (
    vue: any,
    id = '',
    text = '',
    links = [],
    icon = ''
) => newBanner(vue, id, 'blue', icon, text, links);

export const removeBanner = (store: any, bannerId = '') =>
    store.commit(infoMutations.REMOVE_BANNER, bannerId);

export const popDialog = (store: any, content: any, props?: any) =>
    store.commit(infoMutations.ADD_MODAL, { show: true, content, props });

export default {
    errorToast,
    infoToast,
    successToast,
    errorBanner,
    successBanner,
    infoBanner,
    removeBanner,
    popDialog,
};
